export default {
    disclaimer: {
        label_default: "Beru na vědomí a souhlasím s tím, že položky, které objednávám / přijímám, jsou O-I majetkem určeným k použití pro O-I pracovní činnosti, a proto si O-I vyhrazuje právo požadovat vrácení majetku po mém odchodu z O-I (nebo dříve, pokud to O-I vyžaduje).",
        label_type_1: "Potvrzuji, že sebehodnocení pro práci z domova bylo provedeno přesně a v dobré víře a že veškeré vybavení nebo nábytek poskytnutý z lokality O-I nebo objednaný prostřednictvím služby Gear budu používat pro účely mé práce s O-I. Beru na vědomí a souhlasím s tím, že položky, které objednávám/přijímám, jsou O-I majetkem určeným k použití pro O-I pracovní činnosti, a proto si O-I vyhrazuje právo požadovat vrácení majetku po mém odchodu z O-I (nebo dříve, pokud to O-I vyžaduje).",
        errors: {
            required: "Prosím, přijměte podmínky použití"
        }
    },
    cost_center: {
        label: "Kód nákladového střediska",
        placeholder: "Kód nákladového střediska",
        cost_center_not_found: "Zobrazení chybějících nákladových středisk může trvat až 24 hodin. Pokud nevidíte příslušné nákladové středisko, obraťte se na globální servisní oddělení.",
        errors: {
            regex: "Neplatný kód nákladového střediska"
        }
    },
    company_code: {
        label: "Kód společnosti"
    },
    cost_center_name: {
        label: "Název nákladového střediska"
    },
    order_note: {
        label: "Poznámka k objednávce",
        placeholder: "Volitelná poznámka pro manažera ke schválení",
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Upozorňovat mě na novinky ohledně této objednávky"
    },
    "dell_banner":{
        label: "Z důvodu aktualizací systémů Dell se u objednávek Dell odeslaných mezi 1. a 14. srpnem 2026 může vyskytnout značné zpoždění ve zpracování. Během tohoto období očekávejte prodloužené lhůty pro vyřízení. Děkujeme za pochopení."
    }
}